import { Component, OnInit } from '@angular/core';
import { Departement } from '../../models/departement';

@Component({
  templateUrl: './pre-contract-stats.component.html',
  styleUrls: ['./pre-contract-stats.component.scss'],
})
export class PreContractStats implements OnInit {
  departements: Departement[] = [];

  currentDepartement ?: Departement;

  ngOnInit(): void {}

  onSelectDepartement(departement: Departement) {
    this.currentDepartement = departement;
  }
}
